import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { ApiService } from "../../shared/services/api.service";


@Injectable({
  providedIn: 'root'
})
export class LoginService {


  constructor(private apiService: ApiService) { }

  public login(body: any): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'login',
      type: 'POST',
      body
    });
  }

  public logout(): Observable<string> {
    return this.apiService.httpRequestAsText({
      url: 'logout',
      type: 'GET',
    });
  }

  public resetPassword(body): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'resetPassword',
      type: 'POST',
      body
    });
  }

  public updatePassword(body: any): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'updatePassword',
      type: 'POST',
      body
    });
  }

}
